import React from 'react';
import ReactDOM from 'react-dom/client';
import 'ol/ol.css';
import App from './App';
import { SnackbarProvider } from './context/SnackbarContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <SnackbarProvider maxSnack={3}>
       <App />
    </SnackbarProvider>
  </React.StrictMode>
);
